import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { api } from '../api';
import './Dashboard.css';

// Componentes de las secciones
import UsuariosSection from './sections/UsuariosSection';
import VehiculosSection from './sections/VehiculosSection';
import PagosSection from './sections/PagosSection';
import TarifasSection from './sections/TarifasSection';
import EstadisticasSection from './sections/EstadisticasSection';
import KioscoSection from './sections/KioscoSection';

const Dashboard = ({ user, onLogout }) => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalUsuarios: 0,
    totalVehiculos: 0,
    vehiculosActivos: 0,
    suscripcionesVigentes: 0
  });
  const location = useLocation();

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const [usersData, vehuculosData] = await Promise.all([
        api.get('/users'),
        api.get('/vehiculos')
      ]);
      const usuarios  = Array.isArray(usersData)     ? usersData     : usersData.users       || [];
      const vehiculos = Array.isArray(vehuculosData)  ? vehuculosData  : vehuculosData.vehiculos || [];
      setStats({
        totalUsuarios:        usuarios.length,
        totalVehiculos:       vehiculos.length,
        vehiculosActivos:     vehiculos.filter(v => v.usable === true).length,
        suscripcionesVigentes: vehiculos.filter(v => v.isPaid  === true).length,
      });
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    } finally {
      setLoading(false);
    }
  };

  const getActiveSection = () => {
    const path = location.pathname;
    if (path.includes('/usuarios')) return 'usuarios';
    if (path.includes('/vehiculos')) return 'vehiculos';
    if (path.includes('/pagos')) return 'pagos';
    if (path.includes('/tarifas')) return 'tarifas';
    if (path.includes('/kiosco')) return 'kiosco';
    return 'dashboard';
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando panel administrativo...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="sidebar-header">
          <img src="/admin/logo_cyker.png" alt="Cyker" className="sidebar-logo-img" />
          <h2>Admin Panel</h2>
        </div>

        <nav className="sidebar-nav">
          <Link 
            to="/dashboard" 
            className={`nav-item ${getActiveSection() === 'dashboard' ? 'active' : ''}`}
          >
            <span className="nav-icon">📊</span>
            Dashboard
          </Link>
          
          <Link 
            to="/dashboard/usuarios" 
            className={`nav-item ${getActiveSection() === 'usuarios' ? 'active' : ''}`}
          >
            <span className="nav-icon">👥</span>
            Usuarios
          </Link>
          
          <Link 
            to="/dashboard/vehiculos" 
            className={`nav-item ${getActiveSection() === 'vehiculos' ? 'active' : ''}`}
          >
            <span className="nav-icon">🚕</span>
            Vehículos
          </Link>
          
          <Link 
            to="/dashboard/pagos" 
            className={`nav-item ${getActiveSection() === 'pagos' ? 'active' : ''}`}
          >
            <span className="nav-icon">💰</span>
            Pagos
          </Link>
          
          <Link
            to="/dashboard/tarifas"
            className={`nav-item ${getActiveSection() === 'tarifas' ? 'active' : ''}`}
          >
            <span className="nav-icon">💲</span>
            Tarifas
          </Link>

          <Link
            to="/dashboard/kiosco"
            className={`nav-item ${getActiveSection() === 'kiosco' ? 'active' : ''}`}
          >
            <span className="nav-icon">📱</span>
            Kiosco
          </Link>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <strong>{user.email}</strong>
          </div>
          <button className="btn btn-secondary logout-btn" onClick={onLogout}>
            Cerrar Sesión
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <Routes>
          <Route path="/" element={
            <div className="dashboard-home">
              <h1>Panel de Control</h1>
              
              {/* Tarjetas de estadísticas */}
              <div className="stats-grid">
                <div className="stats-card">
                  <div className="stats-icon">👥</div>
                  <div className="stats-content">
                    <h3>{stats.totalUsuarios}</h3>
                    <p>Total Usuarios</p>
                  </div>
                </div>
                
                <div className="stats-card">
                  <div className="stats-icon">🚕</div>
                  <div className="stats-content">
                    <h3>{stats.totalVehiculos}</h3>
                    <p>Total Vehículos</p>
                  </div>
                </div>
                
                <div className="stats-card">
                  <div className="stats-icon">📡</div>
                  <div className="stats-content">
                    <h3>{stats.vehiculosActivos}</h3>
                    <p>Bluetooth Activo</p>
                  </div>
                </div>
                
                <div className="stats-card">
                  <div className="stats-icon">💳</div>
                  <div className="stats-content">
                    <h3>{stats.suscripcionesVigentes}</h3>
                    <p>Suscripciones Vigentes</p>
                  </div>
                </div>
              </div>

              <div className="dashboard-actions">
                <Link to="/dashboard/usuarios" className="btn btn-primary">
                  Gestionar Usuarios
                </Link>
                <Link to="/dashboard/vehiculos" className="btn btn-primary">
                  Gestionar Vehículos
                </Link>
                <Link to="/dashboard/tarifas" className="btn btn-primary">
                  Configurar Tarifas
                </Link>
              </div>
            </div>
          } />
          
          <Route path="/usuarios" element={<UsuariosSection />} />
          <Route path="/vehiculos" element={<VehiculosSection />} />
          <Route path="/pagos" element={<PagosSection />} />
          <Route path="/tarifas" element={<TarifasSection />} />
          <Route path="/kiosco" element={<KioscoSection />} />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;